// extracted by mini-css-extract-plugin
export default {"departments":"dV-z","departmentHeading":"eV-z","departmentSection":"fV-z","departmentName":"gV-z","departmentLink":"hV-z","expandIcon":"iV-z"};